import { Button, Text, VStack, Flex } from '@chakra-ui/react';
import { NovaIconButton } from 'components/ui/NovaIconButton';
import React, { ReactElement } from 'react';
import { ModalDeleteClassProps, SharedModalProps } from 'types/Modal';
import { CloseIcon } from 'assets/icons/v2';
import { CustomModal } from '../CustomModal';
import { CustomModalContent } from '../CustomModalContent';

type Props = SharedModalProps & ModalDeleteClassProps;

export const DeleteClassModal = ({
  handleClose,
  isShown,
  onConfirm,
  className,
}: Props): ReactElement => {
  const handleConfirm = (): void => {
    if (onConfirm) {
      onConfirm();
    }
    handleClose();
  };

  return (
    <CustomModal isOpen={isShown} onClose={handleClose} placement="center" hideHeader size="md">
      <CustomModalContent p="30px">
        <Flex direction="column" gap="30px">
          <Flex direction="column" align="flex-end" gap="5px">
            <NovaIconButton
              aria-label="Schließen"
              variant="primary"
              size="l"
              onClick={handleClose}
              minW="24px"
              h="24px"
              p={0}
              icon={CloseIcon}
              iconProps={{ w: '24px', h: '24px', color: 'text.primary' }}
            />
            <VStack gap="15px" align="flex-start" w="full">
              <Text textStyle="h4.medium" color="text.primary">
                Kurs löschen
              </Text>
              <Text textStyle="body.m.regular" color="text.primary">
                Möchtest du den Kurs {className ? `"${className}"` : ''} wirklich löschen?
              </Text>
            </VStack>
          </Flex>

          <Flex gap="l" justify="flex-end">
            <Button onClick={handleClose} variant="tertiary" px="xl" py="10px" h="auto">
              <Text textStyle="body.m.regular" color="text.secondary">
                Abbrechen
              </Text>
            </Button>
            <Button onClick={handleConfirm} variant="destructive">
              Löschen
            </Button>
          </Flex>
        </Flex>
      </CustomModalContent>
    </CustomModal>
  );
};
